/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestSolvV2ConvertiblePool extends Contract<ITestSolvV2ConvertiblePool> {
  refund: Send<(_slot: BigNumberish) => void, ITestSolvV2ConvertiblePool>
  'refund(uint256)': Send<(_slot: BigNumberish) => void, ITestSolvV2ConvertiblePool>
  settleConvertiblePrice: Send<(_slot: BigNumberish) => void, ITestSolvV2ConvertiblePool>
  'settleConvertiblePrice(uint256)': Send<(_slot: BigNumberish) => void, ITestSolvV2ConvertiblePool>
}

let ITestSolvV2ConvertiblePoolBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestSolvV2ConvertiblePoolBytecode = '0x';
}

// prettier-ignore
export const ITestSolvV2ConvertiblePool = contract<ITestSolvV2ConvertiblePool>(ITestSolvV2ConvertiblePoolBytecode)`
  function refund(uint256 _slot)
  function settleConvertiblePrice(uint256 _slot)
`;